<template>
    <input
        v-if="
            filter.current_shortcut_key != 'station_identity' &&
            filter.current_shortcut_key != 'material_identity' &&
            filter.current_shortcut_key != 'is_activated' &&
            filter.current_shortcut_key != 'strategy'
        "
        @keypress.enter="$parent.$parent.$parent.distributions_filter()"
        v-model="filter.columns[filter.current_shortcut_key]"
        :placeholder="$t('ui.general.search__key', {
            key: $t('models.attributes.distributions.'+filter.current_shortcut_key)
        })"
        type="text"
    >
    <!--
    * ========================================================================
    * = 自行定義
    * ========================================================================
    -->
    <div
        v-else-if="filter.current_shortcut_key == 'station_identity'"
        class="ui selection fluid dropdown right_radius"
        style="min-width: 200px;"
        v-dropdown>
        <div class="text"
            v-for="station in stations"
            v-if="filter.columns.station_identity == station.identity">
            {{ station.name }}
        </div>
        <i class="dropdown icon"></i>
        <div class="menu">
            <div
                v-for="station in stations"
                @click="filter.columns.station_identity = station.identity"
                class="item"
                :class="{
                    'selected active': filter.columns.station_identity == station.identity
                }">
                {{ station.name }}
            </div>
        </div>
    </div>
    <div
        v-else-if="filter.current_shortcut_key == 'material_identity'"
        class="ui selection fluid dropdown right_radius"
        style="min-width: 200px;"
        v-dropdown>
        <div class="text"
            v-for="material in materials"
            v-if="filter.columns.material_identity == material.identity">
            {{ material.name }}
        </div>
        <i class="dropdown icon"></i>
        <div class="menu">
            <div
                v-for="material in materials"
                @click="filter.columns.material_identity = material.identity"
                class="item"
                :class="{
                    'selected active': filter.columns.material_identity == material.identity
                }">
                {{ material.name }}
            </div>
        </div>
    </div>
    <div
        v-else-if="filter.current_shortcut_key == 'strategy'"
        class="ui selection fluid dropdown right_radius"
        style="min-width: 200px;"
        v-dropdown>
        <div class="text"
            v-for="strategy in strategies"
            v-if="filter.columns.strategy == strategy.value">
            {{ strategy.name }}
        </div>
        <i class="dropdown icon"></i>
        <div class="menu">
            <div
                v-for="strategy in strategies"
                @click="filter.columns.strategy = strategy.value"
                class="item"
                :class="{
                    'selected active': filter.columns.strategy == strategy.value
                }">
                {{ strategy.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DistributionsFilterHeaderInputs",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.distributions_module
        },
        filter() {
            return this.current_store.filter
        },
        stations() {
            return [{
                name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.stations)
        },
        materials() {
            return [{
                name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.distributions_module.materials)
        },
        strategies() {
            return [
                {name: this.$t('ui.general.please_select'), value: null},
                // 站點直派
                {name: this.$t('ui.pages.distributions.filter.direct'), value: "direct"},
                // 轉聯運
                {name: this.$t('ui.pages.distributions.filter.intermodal'), value: "intermodal"},
            ]
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>
